import PageHeader from "@/components/PageHeader";
import Testimonials from "@/components/Testimonials";

export default function TestimonialsPage() {
    return (
        <div data-testid="page-testimonials">
            <PageHeader
                eyebrow="Testimonials"
                title={<>The kindest words <em className="italic text-lime">we've been given.</em></>}
                lead="From residents, architects, and one editor. Collected and published with permission."
            />
            <Testimonials />
        </div>
    );
}
